import React from 'react';
import loadable from '@loadable/component';
import preventDirectServerAccess from 'helpers/preventDirectServerAccess';
import { phoneVerificationOnEnterSaga } from './PhoneVerification.onenter.saga';

const PhoneVerification = loadable(() => import('./PhoneVerificationContainer'));
const CodeVerification = loadable(() => import('./CodeVerificationContainer'));
const NumberInput = loadable(() => import('./NumberInputContainer'));

const codeVerificationOnEnter = preventDirectServerAccess(loc => ({
  ...loc,
  pathname: loc.pathname.replace('/enter-code', ''),
}));

export const PhoneVerificationRoute = (store, client) => ({
  path: 'verify-phone',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(phoneVerificationOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb),

  component: props => <PhoneVerification {...props} />,

  childRoutes: [
    {
      path: 'enter-code/**/*',
      component: props => <CodeVerification {...props} />,
      onEnter: codeVerificationOnEnter,
    },
    { path: '**/*', component: props => <NumberInput {...props} /> },
  ],
});
